var __vue_render__ = function __vue_render__() {
  var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { class: _vm.prefix + "-line" }, [_c('span', { class: _vm.prefix + "-dot" }, [_vm._t("dot", [_c('span', { class: _vm.prefix + "-dot-" + _vm.type })])], 2), _c('div', { class: _vm.prefix + "-line-tail" })]);
};
var __vue_staticRenderFns__ = [];

export default {
  render: __vue_render__,

  staticRenderFns: __vue_staticRenderFns__,

  props: {
    type: {
      type: String,
      default: 'normal',
      validator: function validator(value) {
        return ['master', 'normal', 'solid', 'hollow'].indexOf(value) > -1;
      }
    },
    prefix: {
      type: String,
      required: true
    }
  }
};